module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ludvika-7bd1090e209ac41f0080844e0bc76a49.png";